<template>
    <div>
        <div class="wrapper">
            <div class="register-content">
                <div class="register-title">
                    <img alt="" src="@/assets/images/logo.png">
                    注册新账号
                </div>
                <div class="input-group">
                    <span class="icon-wrapper">
                        <i class="el-icon-message"></i>
                    </span>
                    <input v-model="account" placeholder="请输入邮箱" type="email">
                </div>
                <div class="input-group">
                    <span class="icon-wrapper">
                        <i class="el-icon-key"></i>
                    </span>
                    <input v-model="code" placeholder="请输入验证码" type="text">
                    <button :disabled="isSendingCode || countdown > 0" class="send-code-btn"
                        @click="sendVerificationCode">
                        {{ countdown > 0 ? `${countdown}s后重新发送` : '发送验证码' }}
                    </button>
                </div>
                <div class="input-group">
                    <span class="icon-wrapper">
                        <i class="el-icon-lock"></i>
                    </span>
                    <input v-model="password" placeholder="请输入密码" type="password">
                </div>
                <div class="input-group">
                    <span class="icon-wrapper">
                        <i class="el-icon-lock"></i>
                    </span>
                    <input v-model="confirmPassword" placeholder="请确认密码" type="password">
                </div>
                <div class="operate">
                    <button @click="register">注册账号</button>
                </div>
                <div class="login-alert">
                    已有账号？<a href="javascript:" @click="goToLogin">立即登录</a>
                </div>
                <div class="login-aggrement">
                    登录/注册表示同意
                    <a href="javascript:;" @click="openPrivacyPolicy">隐私政策</a>
                    和
                    <a href="javascript:;" @click="openServiceAgreement">服务条款</a>
                </div>
            </div>
        </div>

        <!-- 添加隐私政策弹窗 -->
        <div v-if="showPrivacyPolicy" class="policy-modal">
          <div class="modal-content">
            <iframe :src="privacyPolicyUrl" frameborder="0"></iframe>
            <button @click="closePrivacyPolicy" class="close-btn">返回</button>
          </div>
        </div>

        <!-- 服务条款弹窗 -->
        <div v-if="showServiceAgreement" class="policy-modal">
          <div class="modal-content">
            <iframe :src="serviceAgreementUrl" frameborder="0"></iframe>
            <button @click="closeServiceAgreement" class="close-btn">返回</button>
          </div>
        </div>
    </div>
</template>

<script>
import { register, sendEmailCode } from '@/api'
import { normalizeEmail } from '@/utils/email'

export default {
    name: "RegisterPage",
    data() {
        return {
            account: '',
            code: '',
            password: '',
            confirmPassword: '',
            isSendingCode: false,
            countdown: 0,
            uuid: null,
            showPrivacyPolicy: false,
            showServiceAgreement: false,
            privacyPolicyUrl: 'https://help.srnz.net/service/privicy.html',
            serviceAgreementUrl: 'https://help.srnz.net/service/agreement.html'
        }
    },
    methods: {
        sendVerificationCode() {
            const account = normalizeEmail(this.account)
            if (!this.validateEmail(account)) {
                this.$message.error('请输入有效的邮箱地址');
                return;
            }
            if (this.isSendingCode) {
                return;
            }
            this.isSendingCode = true;
            sendEmailCode({
              email: account,
            }).then(response => {
              this.$message.success('验证码已发送，请查收邮箱');
              this.uuid = response.uuid;
              this.isSendingCode = false;
            }).catch(error => {
              this.$message.error(error);
            });
            this.startCountdown();
        },
        startCountdown() {
            this.countdown = 60;
            const timer = setInterval(() => {
                this.countdown--;
                if (this.countdown === 0) {
                    clearInterval(timer);
                }
            }, 1000);
        },
        validateEmail(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },

        register() {
            const account = normalizeEmail(this.account)
            if(!this.validateEmail(account)) {
                this.$message.error('请输入有效的邮箱地址');
                return;
            }
            if (this.code.trim().length !== 6) {
                this.$message.error('验证码长度应为6位');
                return;
            }
            if (!this.password || this.password.length < 6) {
              this.$message.error('密码长度至少为6位');
            }
            if (this.password !== this.confirmPassword) {
                this.$message.error('确认密码与密码不符');
                return;
            }
            register({
              account,
              code: this.code.trim(),
              password: this.password,
              uuid: this.uuid
            }).then(response => {
              this.$message.success('注册成功');
              this.$router.push('/login/account');
            }).catch(error => {
              this.$message.error(error);
            });
        },
        goToLogin() {
            this.$router.push("/login/account");
        },
        openPrivacyPolicy() {
            this.showPrivacyPolicy = true;
        },
        closePrivacyPolicy() {
            this.showPrivacyPolicy = false;
        },
        openServiceAgreement() {
            this.showServiceAgreement = true;
        },
        closeServiceAgreement() {
            this.showServiceAgreement = false;
        }
    }
}
</script>

<style lang="scss" scoped>
.wrapper {
    background-image: url(~@/assets/images/login-bgc.svg);
    background-size: 100%;
    display: flex;
    height: 100vh;
    justify-content: center;
    align-items: center;
    padding: 0 20px;

    .register-content {
        border-radius: 10px;
        box-shadow: 0px 0px 5px 0px rgba(129, 129, 129, 0.25);
        max-width: 500px;
        width: 100%;
        padding: 60px 80px;
        background-color: $background-color;
        display: flex;
        align-items: center;
        flex-direction: column;

        .register-title {
            font-size: $font-size-Level4;
            line-height: 48px;
            margin-bottom: 30px;

            img {
                width: 36px;
                vertical-align: middle;
                margin-right: 10px;
            }
        }

        .input-group {
            position: relative;
            display: flex;
            align-items: center;
            width: 100%;
            margin-bottom: 20px;

            .icon-wrapper {
                position: absolute;
                left: 16px;
                top: 50%;
                transform: translateY(-50%);
                color: $font-color-fourth;
            }

            input {
                background-color: $background-color-secondary;
                color: $font-color-fourth;
                width: 100%;
                height: 48px;
                border-radius: 25px;
                padding: 0 24px 0 40px;
                border: 1px solid transparent;

                &:focus {
                    border: 1px solid $color-primary;
                    outline: none;
                }
            }

            .send-code-btn {
                position: absolute;
                right: 10px;
                padding: 5px 10px;
                background-color: $color-secondary;
                color: $font-color-secondary;
                border: none;
                border-radius: 15px;
                cursor: pointer;

                &:hover {
                    background-color: $color-primary;
                }

                &:disabled {
                    background-color: #ccc;
                    cursor: not-allowed;
                }
            }
        }

        .operate {
            margin-top: 20px;
            display: flex;
            justify-content: center;
            width: 100%;

            button {
                width: 160px;
                padding: 12px 32px;
                border-radius: 25px;
                border: none;
                color: $font-color-secondary;
                background-color: $color-secondary;
                cursor: pointer;

                &:hover {
                    background-color: $color-primary;
                }
            }
        }

        .login-alert {
            margin-top: 24px;
            text-align: center;

            a {
                color: $font-color-third;
                text-decoration: none;

                &:hover {
                    text-decoration: underline;
                }
            }
        }

        .login-aggrement {
            margin-top: 24px;
            font-size: $font-size-primary;
            color: $font-color-primary;
            text-align: center;

            a {
                color: $font-color-third;
            }
        }
    }
}

.policy-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  z-index: 1000;

  .modal-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0;

    iframe {
      flex-grow: 1;
      width: 100%;
      height: calc(100% - 50px);
      border: none;
    }

    .close-btn {
      height: 50px;
      width: 100%;
      background-color: $color-primary;
      color: white;
      border: none;
      font-size: 16px;
      cursor: pointer;
    }
  }
}
</style>
